<template>
  <div>
    <h3 class="text-h6 mb-4">Opciones Avanzadas</h3>
    
    <v-alert type="info" text dense class="mb-4">
      Configure opciones adicionales del remito.
    </v-alert>

    <v-card class="mb-4">
      <v-card-title class="subtitle-1">
        <v-icon left>mdi-cog</v-icon>
        Opciones de Visualización
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">
            <v-switch
              v-model="opcionesInternas.mostrarCajaR"
              label="Mostrar caja R"
              @change="emitirCambios"
            ></v-switch>
          </v-col>
          <v-col cols="12" md="4">
            <v-switch
              v-model="opcionesInternas.mostrarCodigoBarras"
              label="Mostrar código de barras"
              @change="emitirCambios"
            ></v-switch>
          </v-col>
          <v-col cols="12" md="4">
            <v-switch
              v-model="opcionesInternas.mostrarNumeroPagina"
              label="Mostrar número de página"
              @change="emitirCambios"
            ></v-switch>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="mb-4">
      <v-card-title class="subtitle-1">
        <v-icon left>mdi-format-text</v-icon>
        Formato de Datos
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">
            <v-select
              v-model="opcionesInternas.formatoFecha"
              :items="formatosFecha"
              label="Formato de Fecha"
              outlined
              dense
              @change="emitirCambios"
            ></v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="opcionesInternas.separadorMiles"
              :items="separadores"
              label="Separador de Miles"
              outlined
              dense
              @change="emitirCambios"
            ></v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="opcionesInternas.separadorDecimales"
              :items="separadores"
              label="Separador de Decimales"
              outlined
              dense
              @change="emitirCambios"
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="mb-4">
      <v-card-title class="subtitle-1">
        <v-icon left>mdi-information</v-icon>
        Vista Previa de Formatos
      </v-card-title>
      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr>
                <td><strong>Fecha:</strong></td>
                <td>{{ ejemploFecha }}</td>
              </tr>
              <tr>
                <td><strong>Número:</strong></td>
                <td>{{ ejemploNumero }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'OpcionesAvanzadasEditor',
  
  props: {
    opciones: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      opcionesInternas: {
        mostrarCajaR: false,
        mostrarCodigoBarras: true,
        mostrarNumeroPagina: true,
        formatoFecha: 'DD/MM/YYYY',
        separadorMiles: '.',
        separadorDecimales: ','
      },
      formatosFecha: [
        { text: 'DD/MM/YYYY', value: 'DD/MM/YYYY' },
        { text: 'MM/DD/YYYY', value: 'MM/DD/YYYY' },
        { text: 'YYYY-MM-DD', value: 'YYYY-MM-DD' },
        { text: 'DD-MM-YYYY', value: 'DD-MM-YYYY' }
      ],
      separadores: [
        { text: 'Punto (.)', value: '.' },
        { text: 'Coma (,)', value: ',' },
        { text: 'Espacio ( )', value: ' ' },
        { text: 'Ninguno', value: '' }
      ]
    }
  },

  computed: {
    ejemploFecha() {
      const fecha = new Date()
      const dia = String(fecha.getDate()).padStart(2, '0')
      const mes = String(fecha.getMonth() + 1).padStart(2, '0')
      const anio = fecha.getFullYear()

      switch (this.opcionesInternas.formatoFecha) {
        case 'DD/MM/YYYY':
          return `${dia}/${mes}/${anio}`
        case 'MM/DD/YYYY':
          return `${mes}/${dia}/${anio}`
        case 'YYYY-MM-DD':
          return `${anio}-${mes}-${dia}`
        case 'DD-MM-YYYY':
          return `${dia}-${mes}-${anio}`
        default:
          return `${dia}/${mes}/${anio}`
      }
    },

    ejemploNumero() {
      const numero = 1234567.89
      const parteEntera = Math.floor(numero)
      const parteDecimal = (numero - parteEntera).toFixed(2).substring(2)

      // Formatear parte entera con separador de miles
      const enteroFormateado = parteEntera
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, this.opcionesInternas.separadorMiles)

      return `${enteroFormateado}${this.opcionesInternas.separadorDecimales}${parteDecimal}`
    }
  },

  watch: {
    opciones: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.opcionesInternas = JSON.parse(JSON.stringify(newVal))
        }
      }
    }
  },

  methods: {
    emitirCambios() {
      this.$emit('update', this.opcionesInternas)
    }
  }
}
</script>
